/**
 * Format duration in seconds as "X h Y min" or "X h Y min Z s" (omits seconds when 0).
 */
export function formatFlightTime(seconds: number): string {
  if (seconds <= 0) return '0 h 0 min';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  const sPart = s > 0 ? ` ${s} s` : '';
  return `${h} h ${m} m${sPart}`;
}
